<template>
  <div ref="dropdownRef" class="relative" style="display:flex;align-items:center;">

    <!-- Bell Button -->
    <button class="relative focus:outline-none group" @click="toggleDropdown">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8"
        stroke="currentColor"
        class="w-6 h-6 topbar-icon group-hover:text-indigo-500 transition-colors"
        :class="{ 'bell-ring': unreadCount > 0 }">
        <path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
      </svg>
      <span v-if="totalBadge > 0" class="notif-badge">
        {{ totalBadge > 9 ? '9+' : totalBadge }}
      </span>
    </button>

    <!-- Dropdown -->
    <transition name="notif-drop">
      <div v-show="show" class="notif-panel" :class="{ 'notif-panel--dark': isDark }">

        <!-- Header -->
        <div class="notif-panel__header">
          <div class="notif-panel__title">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" style="width:15px;height:15px;fill:none!important">
              <path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
            </svg>
            Notifikasi
          </div>
          <span v-if="totalBadge > 0" class="notif-panel__count">{{ totalBadge }} baru</span>
        </div>

        <!-- List -->
        <ul class="notif-list">
          <!-- Pending Users pinned item -->
          <li v-if="pendingTotal > 0" class="notif-item notif-item--pending" :class="{ 'notif-item--read': pendingCount === 0 }" @click="goToPendingUsers">
            <div class="notif-item__unread-dot" :class="{ 'notif-item__unread-dot--read': pendingCount === 0 }"></div>
            <div class="notif-item__avatar notif-item__avatar--pending">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" style="width:16px;height:16px;fill:none!important">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
              </svg>
            </div>
            <div class="notif-item__body">
              <div class="notif-item__action">{{ pendingCount }} pengguna menunggu persetujuan</div>
              <div class="notif-item__actor notif-item__actor--pending">Klik untuk tinjau</div>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="notif-item__arrow" style="fill:none!important">
              <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
            </svg>
          </li>

          <li
            v-for="notification in notifications"
            :key="notification.id"
            class="notif-item"
            :class="{ 'notif-item--read': notification.read }"
            @click="handleNotificationClick(notification)"
          >
            <div v-if="!notification.read" class="notif-item__unread-dot"></div>
            <div v-else class="notif-item__unread-dot notif-item__unread-dot--read"></div>

            <div class="notif-item__avatar">{{ getInitial(notification.message) }}</div>

            <div class="notif-item__body">
              <div class="notif-item__action">{{ getAction(notification.message) }}</div>
              <div v-if="getActor(notification.message)" class="notif-item__actor">
                oleh {{ getActor(notification.message) }}
              </div>
              <div v-if="notification.ticket_uid || getTicket(notification.message)" class="notif-item__ticket">
                <span class="notif-item__ticket-badge">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" style="width:10px;height:10px;fill:none!important">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 010 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a3 3 0 010-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375z" />
                  </svg>
                  <span v-if="notification.ticket_uid">#{{ notification.ticket_uid }}</span>
                </span>
                <span v-if="getTicket(notification.message)" class="notif-item__ticket-title">{{ getTicket(notification.message) }}</span>
              </div>
              <div class="notif-item__time">{{ notification.created_at }}</div>
            </div>

            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="notif-item__arrow" style="fill:none!important">
              <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
            </svg>
          </li>

          <!-- Empty state -->
          <li v-if="notifications.length === 0" class="notif-empty">
            <div class="notif-empty__icon">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.4" stroke="currentColor" style="width:28px;height:28px;fill:none!important">
                <path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
              </svg>
            </div>
            <p class="notif-empty__text">Tidak ada notifikasi baru</p>
          </li>
        </ul>

        <!-- Footer -->
        <div v-if="notifications.length > 0" class="notif-panel__footer">
          <button class="notif-panel__mark-all" @click="markAllAsRead">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" style="width:12px;height:12px;fill:none!important">
              <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
            </svg>
            Tandai semua dibaca
          </button>
        </div>

      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'NotificationDropdown',
  data() {
    return {
      show: false,
      notifications: [],
      unreadCount: 0,
      lastUnreadCount: 0,
      pendingCount: 0,
      pendingTotal: 0,
      isDark: false,
      fetchToken: 0, // bumped on every fetch/mutation so stale poll responses are dropped
    }
  },
  computed: {
    totalBadge() {
      return this.unreadCount + this.pendingCount
    },
  },
  mounted() {
    this.detectDark()
    this.darkObserver = new MutationObserver(this.detectDark)
    const layoutEl = document.querySelector('.layout-app')
    if (layoutEl) this.darkObserver.observe(layoutEl, { attributes: true, attributeFilter: ['class'] })

    this.fetchNotifications()
    document.addEventListener('click', this.handleOutsideClick)
    this.intervalId = setInterval(() => this.fetchNotifications(), 5000)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleOutsideClick)
    if (this.intervalId) clearInterval(this.intervalId)
    if (this.darkObserver) this.darkObserver.disconnect()
  },
  methods: {
    detectDark() {
      this.isDark = document.querySelector('.layout-app')?.classList.contains('dark') ?? false
    },

    toggleDropdown() {
      this.show = !this.show
      if (this.show) this.fetchNotifications()
    },

    handleOutsideClick(event) {
      if (!this.show) return
      if (this.$refs.dropdownRef && !this.$refs.dropdownRef.contains(event.target)) {
        this.show = false
      }
    },

    fetchNotifications() {
      const token = ++this.fetchToken
      axios.get('/dashboard/notifications')
        .then(res => {
          // Drop this response if a newer fetch or a mark-as-read superseded it,
          // otherwise a stale in-flight poll repaints already-read notifications.
          if (token !== this.fetchToken) return
          const data = res.data || {}
          const unreadCount = data.unread_count ?? 0
          const pendingCount = data.pending_count ?? 0
          if (unreadCount > this.lastUnreadCount && !this.show) {
            this.show = true
          }
          this.notifications = data.notifications ?? []
          this.unreadCount = unreadCount
          this.lastUnreadCount = unreadCount
          this.pendingCount = pendingCount
          this.pendingTotal = data.pending_total ?? 0
        })
        .catch(() => {})
    },

    goToPendingUsers() {
      axios.post('/dashboard/notifications/pending/acknowledge').finally(() => {
        this.pendingCount = 0
        window.location.href = '/dashboard/users/pending'
      })
    },

    markAllAsRead() {
      this.fetchToken++ // invalidate any in-flight poll so it can't revive the count
      this.notifications.forEach(n => { n.read = true })
      this.unreadCount = 0
      this.lastUnreadCount = 0
      axios.post('/dashboard/notifications/read')
        .then(() => this.fetchNotifications()) // resync with server truth
        .catch(() => {})
    },

    async handleNotificationClick(notification) {
      try {
        const url = notification.url ?? notification.data?.url
        if (!notification.read) {
          await axios.post('/dashboard/notifications/' + notification.id + '/read')
          notification.read = true
          this.unreadCount = Math.max(0, this.unreadCount - 1)
          this.lastUnreadCount = this.unreadCount
        }
        if (url) window.location.href = url
      } catch {}
    },

    // Parse: "Tantan Faturrahman mengupdate tiket: "Test" - Status: Pending → On Process"
    parseMessage(message) {
      if (!message) return { actor: 'Sistem', action: 'Notifikasi baru', ticket: '' }

      let actor = '', action = '', ticket = ''

      // Ambil nama tiket dari dalam tanda kutip
      const quoted = message.match(/"([^"]+)"/)
      ticket = quoted ? quoted[1] : ''

      if (message.includes(' mengupdate tiket:')) {
        actor = message.split(' mengupdate tiket:')[0]
        const dashIdx = message.lastIndexOf(' - ')
        action = dashIdx !== -1 ? message.substring(dashIdx + 3) : 'Tiket diupdate'
      } else if (message.includes(' menyebut kamu di komentar tiket:')) {
        actor = message.split(' menyebut kamu di komentar tiket:')[0]
        action = 'Anda disebut dalam komentar'
      } else if (message.startsWith('Komentar baru')) {
        actor = ''
        action = 'Komentar baru ditambahkan'
      } else if (message.includes('menugaskan tiket baru:')) {
        actor = message.split(' menugaskan tiket baru:')[0]
        action = 'Anda ditugaskan ke tiket baru'
      } else if (message.includes('ditugaskan tiket baru')) {
        actor = 'Sistem'
        action = 'Anda ditugaskan ke tiket baru'
      } else {
        action = message
      }

      return { actor: this.titleCase(actor.trim()), action: action.trim(), ticket: ticket.trim() }
    },

    // Selaraskan nama orang ke Title Case untuk tampilan: "ADAM SENTOSA" → "Adam Sentosa".
    // Hanya memengaruhi tampilan, data di DB tidak diubah.
    titleCase(str) {
      if (!str) return str
      return str.toLowerCase().replace(/\b\p{L}/gu, (c) => c.toUpperCase())
    },

    getInitial(message) {
      const { actor } = this.parseMessage(message)
      return actor ? actor.charAt(0).toUpperCase() : 'S'
    },

    getActor(message) {
      return this.parseMessage(message).actor || null
    },

    getAction(message) {
      return this.parseMessage(message).action
    },

    getTicket(message) {
      return this.parseMessage(message).ticket
    },
  },
}
</script>

<style scoped>
/* ── Transition ── */
.notif-drop-enter-active,
.notif-drop-leave-active { transition: opacity 0.18s ease, transform 0.18s ease; }
.notif-drop-enter-from,
.notif-drop-leave-to    { opacity: 0; transform: translateY(-6px) scale(0.98); }

/* ── Badge ── */
.notif-badge {
  position: absolute;
  top: -4px; right: -6px;
  background: #ef4444;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  border-radius: 999px;
  min-width: 17px;
  height: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 3px;
}

/* ── Panel ── */
.notif-panel {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  width: 380px;
  border-radius: 16px;
  z-index: 50;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  box-shadow: 0 20px 48px rgba(0,0,0,.10), 0 4px 12px rgba(0,0,0,.06);
}

@media (max-width: 480px) {
  .notif-panel {
    width: calc(100vw - 24px);
    right: -12px;
  }
}

.notif-panel--dark {
  background: #18181f;
  border-color: #2a2a3a;
  box-shadow: 0 20px 48px rgba(0,0,0,.55), 0 4px 12px rgba(0,0,0,.35);
}

/* ── Header ── */
.notif-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px 13px;
  border-bottom: 1px solid #f1f5f9;
}

.notif-panel--dark .notif-panel__header {
  border-color: #252530;
}

.notif-panel__title {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
}

.notif-panel--dark .notif-panel__title {
  color: #e2e8f0;
}

.notif-panel__count {
  font-size: 11px;
  font-weight: 600;
  color: #dc2626;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 999px;
  padding: 2px 9px;
}

.notif-panel--dark .notif-panel__count {
  color: #f87171;
  background: rgba(239,68,68,.12);
  border-color: rgba(239,68,68,.25);
}

/* ── List ── */
.notif-list {
  list-style: none;
  margin: 0;
  padding: 6px;
  max-height: 360px;
  overflow-y: auto;
}

/* ── Item ── */
.notif-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 11px 10px 11px 12px;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.12s ease;
}

.notif-item:hover {
  background: #f8fafc;
}

.notif-panel--dark .notif-item:hover {
  background: rgba(255,255,255,.05);
}

.notif-item__unread-dot {
  flex-shrink: 0;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #15803d;
  margin-top: 7px;
}

.notif-item__unread-dot--read {
  background: transparent;
}

.notif-item__avatar {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: linear-gradient(135deg, #15803d, #166534);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ── Read items ── */
.notif-item--read {
  opacity: 0.55;
}

.notif-item--read .notif-item__avatar {
  background: #cbd5e1;
}

.notif-panel--dark .notif-item--read .notif-item__avatar {
  background: #374151;
}

.notif-item__body {
  flex: 1;
  min-width: 0;
}

.notif-item__action {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.4;
  margin-bottom: 2px;
}

.notif-panel--dark .notif-item__action {
  color: #e2e8f0;
}

.notif-item__actor {
  font-size: 11.5px;
  font-weight: 500;
  color: #15803d;
  margin-bottom: 5px;
}

.notif-panel--dark .notif-item__actor {
  color: #4ade80;
}

.notif-item__ticket {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
  overflow: hidden;
}

.notif-item__ticket-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 11px;
  font-weight: 700;
  color: #15803d;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 5px;
  padding: 1px 6px;
  white-space: nowrap;
  flex-shrink: 0;
}

.notif-panel--dark .notif-item__ticket-badge {
  color: #4ade80;
  background: rgba(74,222,128,.08);
  border-color: rgba(74,222,128,.2);
}

.notif-item__ticket-title {
  font-size: 11.5px;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.notif-panel--dark .notif-item__ticket-title {
  color: #ffffff;
}

.notif-item__time {
  font-size: 11px;
  color: #94a3b8;
}

.notif-panel--dark .notif-item__time {
  color: #4b5563;
}

.notif-item__arrow {
  flex-shrink: 0;
  width: 13px;
  height: 13px;
  color: #d1d5db;
  margin-top: 5px;
  transition: color 0.12s;
}

.notif-item:hover .notif-item__arrow { color: #15803d; }
.notif-panel--dark .notif-item__arrow { color: #2d2d3d; }
.notif-panel--dark .notif-item:hover .notif-item__arrow { color: #4ade80; }

/* ── Empty ── */
.notif-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 36px 16px;
  list-style: none;
}

.notif-empty__icon {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #cbd5e1;
}

.notif-panel--dark .notif-empty__icon {
  background: #252530;
  color: #374151;
}

.notif-empty__text {
  font-size: 13px;
  color: #94a3b8;
  margin: 0;
}

.notif-panel--dark .notif-empty__text {
  color: #4b5563;
}

/* ── Footer ── */
.notif-panel__footer {
  padding: 10px 16px;
  border-top: 1px solid #f1f5f9;
  display: flex;
  justify-content: center;
}

.notif-panel--dark .notif-panel__footer {
  border-color: #252530;
}

.notif-panel__mark-all {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 600;
  color: #15803d;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 10px;
  border-radius: 6px;
  transition: background 0.12s, color 0.12s;
}

.notif-panel__mark-all:hover {
  background: #f0fdf4;
  color: #166534;
}

.notif-panel--dark .notif-panel__mark-all {
  color: #4ade80;
}

.notif-panel--dark .notif-panel__mark-all:hover {
  background: rgba(74,222,128,.1);
  color: #86efac;
}

/* ── Pending Users item ── */
.notif-item--pending {
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 10px;
  margin-bottom: 4px;
}

.notif-item--pending:hover {
  background: #fef3c7;
}

.notif-panel--dark .notif-item--pending {
  background: rgba(251,191,36,.08);
  border-color: rgba(251,191,36,.2);
}

.notif-panel--dark .notif-item--pending:hover {
  background: rgba(251,191,36,.13);
}

.notif-item__avatar--pending {
  background: linear-gradient(135deg, #d97706, #f59e0b) !important;
}

.notif-item__actor--pending {
  color: #b45309 !important;
}

.notif-panel--dark .notif-item__actor--pending {
  color: #fbbf24 !important;
}

/* ── Bell animation ── */
.bell-ring {
  animation: bell-ring 3s ease-in-out infinite;
  transform-origin: top center;
}

@keyframes bell-ring {
  0%, 80%, 100% { transform: rotate(0deg); }
  85%  { transform: rotate(12deg); }
  90%  { transform: rotate(-10deg); }
  95%  { transform: rotate(6deg); }
  98%  { transform: rotate(-3deg); }
}
</style>
